import { AccountTieIcon } from './AccountTieIcon';

/**
 * author: Michael Irigoyen
 * id 5EF0B9EA-FECB-409C-999C-FE1ECF0C8B01
 * name account-tie
 * version: 3.3.92
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-tie.svg
 * tags
 * - Account / User 
 * - People / Family 
 */
export const PersonTieIcon = AccountTieIcon;
export default PersonTieIcon